<template>
  <div class="container-fluid px-0">
    <div class="row">
      <div class="col-xl-12">
        <div class="banner">
          <el-image v-if="newsClass.ImgUrl" style="width: 100%;height: 210px;" :src="ossUrl+newsClass.ImgUrl" fit="cover" @click="cancelStyle">
            <template slot="error">
              <img class="el-image__inner" style="object-fit: cover;" :src="url + newsClass.ImgUrl" alt="">
            </template>
          </el-image>
          <h3 class="banner__title">
            {{ newsClass.Name }}
          </h3>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-10">
        <div class="news">
          <h3 class="news__title">
            {{ news.Name }}
          </h3>
          <div v-html="news.Content" class="news__content">

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      url: 'https://jsg1.oss-cn-beijing.aliyuncs.com/',
      newsClass: {},
      news: {},
    };
  },

  watch: {

  },

  mounted() {

  },

  created() {
    this.sApi('getNewsInfo', {ID: this.$route.params.ID}).then(res => {
      this.news = res.Data
      // 新闻分类
      this.sApi('getNewsClassInfo', {ID: this.news.ClassID}).then(res => {
        this.newsClass = res.Data
      })
    })
  },

  methods: {
    cancelStyle(){
      document.body.style='overflow:auto';
    },
  },
};
</script>

<style lang="scss" >
  .banner{
    position: relative;
    width: 100%;
    overflow: hidden;
    background: #007bff;
    &__title{
      font-size: 32px;
      color: #ffffff;
      letter-spacing: .2rem;
      font-weight: bold;
      padding: 1rem 2rem;
      text-align: center;
    }
  }
  .news{
    position: relative;
    background: #ffffff;
    padding: 2rem 1.5rem;
    margin: 3rem 15px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
    &__title{
      font-size: 24px;
      text-align: center;
      margin-bottom: 2rem;
      padding-bottom: 1.5rem;
      border-bottom: 1px solid #eeeeee;
    }
    &__content{
      p{
        font-size: 14px;
        line-height: 30px;
      }
      img{
        width: 100%;
        display: block;
        height: auto;
      }
    }
  }
</style>
